import modules from './modules/module.routes.js';

export default {
    /**
     * This is app2 layout
     * Here we dont have any global dependencies like 
     * global variables, global css
     * This route will be used to test independent reusable components
     * Children routes for this app layout generated by running `npm run layout2-routes` npm command
     */
    path: "/app2",
    component: () => import(/* webpackChunkName: "independent-empty-layout" */ '@/Layouts/independent-empty-layout/layout.vue'),
    children: [
        {
            path: "/",
            name: "app2",
            redirect: {
                name: modules[0].name
            },
            component: () => import(/* webpackChunkName: "app-components-entry" */ './App.vue'),
            children: modules
        },
    ],
}